import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './AddDistrictDetails.scss';
import fetch from '../../../../../core/fetch';
import { changeLayerStyle } from '../../../../../actions/district';
import ModalAlert from '../../../ModalAlert';

const fastStyleMargin = {
    marginTop: '7px',
  };
  const StyleButton = {
    marginTop: '20px',
    //textAlign: 'center'
  };

  class ListViews extends React.Component {
    constructor(props){
      super(props);
      this.state = {
        views: [],
        godzina: 0,
        doba: 0,
        miesiac: 0
      };
    }

    componentWillMount() {
        let url = `${process.env.OLD_IHUB}/get/cieszanow`;
        fetch(url, {
            method: 'GET'
        })
        .then(r => {
            return r.json();
        })
        .then(resp => {
            this.setState({
            godzina: resp.godzina,
            miesiac: resp.miesiac,
            doba: resp.doba
            })
        })

        let url2 = `${process.env.OLD_IHUB}/select/cieszanow`;
        fetch(url2, {
            method: 'GET'
        })
        .then(r => {
            return r.json();
        })
        .then(resp => {
            this.setState({
                views: resp.result,
            });
        });
    }


    render() {
      return (
        <div className="col-xs-12">
            <h2>Liczba odsłon</h2>
            Aktualna godzina: {this.state.godzina}<br />
            Dzisiaj: {this.state.doba}<br />
            Bieżący miesiąc: {this.state.miesiac}<br />
            <hr />
            <table className="table">
            <thead>
                <tr>
                <th>Data wizyty</th>
                <th>Sieć</th>
                <th>IP</th>
                <th>Identyfikator sesji</th>
                </tr>
            </thead>
            <tbody>
                {this.state.views.map((v, i) => <tr key={i}>
                    <td>{v.visit_date}</td>
                    <td>{v.siec}</td>
                    <td>{v.ip}</td>
                    <td>{v.identyfikatorsesji}</td>
                </tr>)}
            </tbody>
            </table>
        </div>
      );
    }
  }


  export default withStyles(s)(ListViews);



// WEBPACK FOOTER //
// src/components/Modals/Settings/Panels/ListViews/ListViews.js